import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import { Button, FormControl, FormLabel, Modal, TextareaAutosize, TextField } from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { useParams } from "react-router-dom";
import api from "../../../../utils/api";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";


export const PerfilMembroEdit = () => {
  const { goBack } = useNav();
  const { startLoading, stopLoading, isLoading } = useLoading();
  const { setMensagemError, setMensagemSuccess } = useErrorSuccess();
  const { id } = useParams();

  const getPerfilMembro = async () => {
    let req = await api.get('usuarioperfil/' + id);
    setValue('descricao', req.data.descricao);
    setValue('observacoes', req.data.observacoes);
    return;
  }

  const {
    register,
    setValue,
    handleSubmit
  } = useForm<{ descricao: string, observacoes: string }>({
    defaultValues: {
      descricao: null,
      observacoes: null
    }
  });

  useEffect(() => {
    getPerfilMembro();
  }, [])

  const put = handleSubmit(async (values) => {
    startLoading();
    try {
      await api.put("usuarioperfil/" + id, values);
      setMensagemSuccess("Alterado com sucesso!");
      goBack();
    } catch (error) {
      setMensagemError(
        JSON.stringify(error?.response?.data?.mensagem, null, 2) ||
          "Erro ao alterar usuário"
      );
    } finally {
      stopLoading();
    }
  });

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal props={{ display: 'grid', rowGap: '4px' }}>
          <FormControl fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <FormControl fullWidth>
            <FormLabel>Observação</FormLabel>
            <TextareaAutosize
              style={{
                resize: 'none',
                minHeight: 60,
                borderRadius: 4,
                borderColor: '#ccc'
              }}
              {...register('observacoes')}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained" disabled={isLoading} onClick={put}>Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
